const getIsAuthorized = () => {
  const token = JSON.parse(localStorage.getItem('Auth-_burry_PurpleWave'))
  if (token) {
    return token.expires > new Date().toISOString()
  }
  return false
}

export { getIsAuthorized }
